const initialHotelRules = {
  checkInTimeFrom: "",
  checkOutTimeBefore: "",
  earlyCheckInCharge: 0,
  lateCheckOutCharge: 0,
  smokingRule: "",
  petAllow: null,
  damageCompensation: "",
  houseKeepingPolicy: "",
  noShowCharge: 0,
  lostAndFoundPolicy: "",
  refundPolicy: "",
  forceMajeureEvent: "",
  hotelRule: "",
};
export { initialHotelRules };
